import React, { useState, useContext } from 'react';
import { EyePassword } from './EyePassword';
import { AuthContext } from '../../../service/auth/JWTContext';
import { Button, Logo } from '@vt/vt-ui';

const LoginForm = ({ onSubmit, onChange, formData }) => {
  const { isLoading } = useContext(AuthContext);
  const [eye, setEye] = useState(true);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form data-testid="submit-form" className="px-10 py-10" onSubmit={handleSubmit}>
      <div className="flex flex-col items-center mb-4">
        <div className="w-[65px] h-[65px] mb-4">
          <a href="#">
            <Logo variant={'withoutBg'} size="xl" className='vt-m-auto' />
          </a>
        </div>
        <div className="font-bold text-center text-[#e5e5e5]">Login</div>
      </div>
      <div className="flex justify-between mb-4">
        <div className="text-[#e5e5e5] text-xs">You don&apos;t have an account?</div>
        <div className="text-[#11EF9E] font-bold text-xs">
          <a href="https://www.iux.com/th/register" target="_blank" rel="noreferrer">
            Register
          </a>
        </div>
      </div>
      <label className="text-xs text-[#8d8d8d] mb-1 pl-1">Email</label>
      <input
        type="text"
        id="email"
        data-testid="input-email"
        name="email"
        placeholder="Email"
        className="rounded-lg h-[40px] w-full px-2 mb-4 text-sm outline-none bg-transparent border border-[#696969] text-[#e5e5e5] transition-colors duration-200 hover:border-[#0FEF9E] focus:border-[#0FEF9E] hover:cursor-pointer focus:cursor-text focus:caret-[#0FEF9E]"
        onChange={onChange}
      />
      <label className="text-xs text-[#8d8d8d] mb-1 pl-1">Password</label>
      <div className="relative">
        <input
          id="password"
          data-testid="input-password"
          type={!eye ? 'text' : 'password'}
          placeholder="Password"
          name="password"
          className="rounded-lg h-[40px] w-full px-2 mb-5 text-sm outline-none bg-transparent border border-[#696969] text-[#e5e5e5] transition-colors duration-200 hover:border-[#0FEF9E] focus:border-[#0FEF9E] hover:cursor-pointer focus:cursor-text focus:caret-[#0FEF9E]"
          onChange={onChange}
        />
        <EyePassword setEye={setEye} eye={eye} />
      </div>
      <div className="flex justify-between mb-8">
        <div></div>
        <div className="text-[#11EF9E] font-bold text-xs">
          <a href="https://www.iux.com/en/forgot-password" target="_blank" rel="noreferrer">
            Forgot your password?
          </a>
        </div>
      </div>
      <Button
        className="h-[35px] w-full mb-5"
        type="submit"
        role="button"
        disabled={isLoading}>
        <div className="flex items-center justify-center gap-3">
          <div>{isLoading ? 'Logging in...' : 'Login'}</div>
        </div>
      </Button>
      <p className="text-[#9f9f9f] text-center leading-4">
        Trading CFDs and leveraged products generally involves a high risk of loss and you may lose
        all your investment.
      </p>
    </form>
  );
};

export default LoginForm;
